import { useEffect } from 'react'
import { useFormikContext } from 'formik'

import { toUserSelectItem } from '../../../../../User'
import { TASK_FORM_MANAGER_FIELD_NAME } from '../../../TaskForm.constants'

export function useManagerFieldFillOnEdit({
  currentUser,
  isEditing,
  onSetInitialValues,
}) {
  const { values } = useFormikContext()

  useEffect(() => {
    if (isEditing && currentUser && !values[TASK_FORM_MANAGER_FIELD_NAME]) {
      onSetInitialValues(prev => ({
        ...prev,
        [TASK_FORM_MANAGER_FIELD_NAME]: toUserSelectItem(currentUser),
      }))
    }
  }, [currentUser, isEditing])
}
